<template>
  <div>
    <div class="px-3 py-2">
      <b-row class="align-items-center">
        <b-col sm="6">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="icon-magnifier"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text"
                          class="form-control"
                          placeholder="Search by invoice number, account#, account name, remarks"
                          autocomplete="off"
                          v-model="serverParams.keyword"
                          @input="onChange" />
          </b-input-group>
        </b-col>
        <b-col sm="4">
          <treeselect v-model="serverParams.account"
                      placeholder="Select Account"
                      @input="onChange"
                      :options="options.accounts" />
        </b-col>
        <b-col sm="2">
          <treeselect v-model="serverParams.paymentMethod"
                      placeholder="Select Payment Method"
                      :options="options.paymentMethod"
                      @input="onChange" />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="4">
          <form-group label="Payment Month" :use-horizontal="false">
            <b-form-input type="month"
                          placeholder="Period"
                          autocomplete="off"
                          v-model="serverParams.period"
                          @input="onChange" />
          </form-group>
        </b-col>
        <b-col sm="4">
          <form-group label="‎‎ " :use-horizontal="false">
            <BuildingDropdown :server-params="serverParams"
                              :on-select="getAccounts" />
          </form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { paymentMethod } from "@/shared/options";
  import BuildingDropdown from "@/components/common/BuildingDropdown";
  export default {
    props: {
      serverParams: Object,
    },
    data: () => ({
      options: {
        paymentMethod,
        accounts: [],
      },
    }),
    components: {
      BuildingDropdown,
    },
    created() {
      const self = this;
      this.getAccounts();
    },
    methods: {
      onChange() {
        this.serverParams.pageNumber = 1;
        this.$emit("onChange", this.serverParams);
      },
      getAccounts() {
        const self = this;
        self.$store
          .dispatch("apis/get", {
            url: "/account",
            params: {
              ...self.serverParams,
              orderBy: 'accountId'
            }
          })
          .then((response) => {
            if (response.error) {
              self.$message.error({
                zIndex: 10000,
                message: response.message,
              });
            } else {
              self.options.accounts = response.data.data.map((x) => ({
                id: x.accountId,
                label: `${x.accountId}# ${x.name}`,
              }));
            }
          });
      },
    },
  };
</script>
